import store from "../../store";

const MedicalSurveillanceReq = () =>
  import(
    "@/components/medical_surveillance/MedicalSurveillanceRequirements.vue"
  );
const RequirementListing = () =>
  import("@/components/medical_surveillance/RequirementListing.vue");
const RecordListing = () =>
  import("@/components/medical_surveillance/RecordListing.vue");
const AddRecord = () =>
  import("@/components/medical_surveillance/AddRecord.vue");
const EditRecord = () =>
  import("@/components/medical_surveillance/EditRecord.vue");
const RequirementRuleListing = () =>
  import("@/components/medical_surveillance/RequirementRuleListing.vue");
const RequirementRuleForm = () =>
  import("@/components/medical_surveillance/RequirementRuleForm.vue");
const RequirementRule = () =>
  import("@/components/medical_surveillance/RequirementRule.vue");
const ServiceTypeForm = () =>
  import("@/components/medical_surveillance/ServiceTypeForm.vue");
const ServiceTypesListing = () =>
  import("@/components/medical_surveillance/ServiceTypesListing.vue");
const RequirementRuleReset = () =>
  import("@/components/requirements/RequirementRuleReset.vue");
const AnimalContactRecords = () =>
  import("@/components/medical_surveillance/AnimalContactRecords.vue");

const dispatchFetches = (to, from, next) => {
  store.dispatch("fetchServiceTypes");
  store.dispatch("fetchMedicalSurveillanceUserPermissions");
  next();
};

const routes = [
  // URL in RAFT where Vue JS component needs to match the following.
  // Path is used in B4, Alias in B3 if they are different paths.
  {
    name: "medical_surveillance_wrapper",
    component: MedicalSurveillanceReq,
    path: "/raft/medical-surveillance",
    beforeEnter: dispatchFetches,
    children: [
      {
        path: "/raft/medical-surveillance/listing",
        name: "medical_surveillance_listing",
        component: RequirementListing,
      },
      {
        path: "/raft/medical-surveillance/records",
        name: "medical_surveillance_records",
        component: RecordListing,
      },
      {
        path: "/raft/medical-surveillance/records/animal-contact",
        name: "medical_surveillance_animal_contact_records",
        component: AnimalContactRecords,
      },
      {
        path: "/node/:groupId/medical-surveillance",
        alias: "/node/:groupId/medical-surveillance/listing",
        name: "group_medical_surveillance_listing",
        component: RequirementListing,
        props: true,
      },
      {
        path: "/node/:groupId/medical-surveillance/records",
        name: "group_medical_surveillance_records",
        component: RecordListing,
        props: true,
      },
      {
        path: "/user/:userId/medical-surveillance",
        name: "user_medical_surveillance_listing",
        component: RequirementListing,
        props: true,
      },
      {
        path: "/user/:userId/medical-surveillance/listing",
        name: "user_medical_surveillance_requirements",
        component: RequirementListing,
        props: true,
      },
      {
        path: "/user/:userId/medical-surveillance/records",
        name: "user_medical_surveillance_records",
        component: RecordListing,
        props: true,
      },
      {
        path: "/user/:userId/medical-surveillance/records/:recordId/view",
        name: "view_user_medical_surveillance_record",
        component: EditRecord,
        alias: "/user/:userId/medical-surveillance/records/:recordId",
        props: true,
      },
      {
        path: "/raft/medical-surveillance/record/:recordId",
        name: "view_medical_surveillance_record",
        component: EditRecord,
        props: { disableEditMode: true },
      },
      {
        path: "/raft/medical-surveillance/add-unlinked-record",
        name: "add_unlinked_medical_surveillance_record",
        component: AddRecord,
        props: { unlinked: true },
      },
      {
        path: "/raft/medical-surveillance/add-record/:serviceType",
        name: "add_medical_surveillance_record",
        component: AddRecord,
        props: true,
      },
      {
        path: "/raft/medical-surveillance/edit-record/:recordId",
        name: "edit_medical_surveillance_record",
        component: EditRecord,
        props: true,
      },
      {
        path: "/raft/medical-surveillance/requirements",
        name: "medical_surveillance_requirement_rules",
        component: RequirementRuleListing,
        props: true,
      },
      {
        path: "/raft/medical-surveillance/requirements/inactive",
        name: "medical_surveillance_requirement_rules_inactive",
        component: RequirementRuleListing,
        props: { showInactive: true },
      },
      {
        path: "/raft/medical-surveillance/add-requirement-rule",
        name: "add_medical_requirement_rule",
        component: RequirementRuleForm,
        props: true,
      },
      {
        path: "/raft/medical-surveillance/requirement-rule/view/:requirement_id",
        name: "view_medical_requirement_rule",
        component: RequirementRule,
        props: true,
      },
      {
        path: "/raft/medical-surveillance/requirement-rule/edit/:requirement_id",
        name: "edit_medical_requirement_rule",
        component: RequirementRuleForm,
        props: true,
      },
      {
        path: "/raft/medical-surveillance/service-type/edit/:service_type_id",
        name: "edit_medical_surveillance_service_type",
        component: ServiceTypeForm,
        props: true,
      },
      {
        path: "/raft/medical-surveillance/service-type/add",
        name: "add_medical_surveillance_service_type",
        component: ServiceTypeForm,
        props: true,
      },
      {
        path: "/raft/medical-surveillance/service-types",
        name: "service-types-listing",
        component: ServiceTypesListing,
      },
      {
        path: "/raft/medical-surveillance/requirement/:requirement_rule_bundle/:requirement_rule_id/reset/:target_type?/:target_bundle?/:target_id?",
        name: "reset_medical_surveillance_requirement",
        component: RequirementRuleReset,
        props: true,
      },
    ],
  },
];

const globalComponents = {
  MedicalSurveillanceReq,
  RequirementListing,
  RecordListing,
  AnimalContactRecords,
  EditRecord,
  AddRecord,
  RequirementRule,
  RequirementRuleListing,
  RequirementRuleForm,
  ServiceTypeForm,
  ServiceTypesListing,
  RequirementRuleReset,
};

export {
  routes as medSurveillanceRoutes,
  globalComponents as medSurveillanceGlobalComponents,
};
